module.exports = __webpack_public_path__ + "img/470.938ca715.jpg";